// const BaseUrl = 'https://devtugotwo.ezzysales.com/api/';
// const frontendURL = 'http://dev-tugo.ezzysales.com/';

const BaseUrl = 'https://api.tugoonline.co.uk/api/'; // LIVE
const frontendURL = 'https://www.tugoonline.co.uk/';

export { BaseUrl, frontendURL} 